// componente che contiene tutti i metodi utilizzati per gestire i pannelli; queste funzioni sono richiamate esternamente
// dalle altre componenti che costituiscono tutto il blocco di gestione pannelli (tts-edit e tts-list)

import { Injectable } from '@angular/core';
import { Tts } from './tts.model';
import { Subject } from 'rxjs';

@Injectable()
export class TtsService {
  private tts: Tts[] = [];
  ttsChanged = new Subject<Tts[]>();
  ttsEditMode = new Subject<number>();
  ttscountChanged = new Subject<string>();
  private ttscount: string = '';

  constructor(
  ) { }

  ngOnInit() {
  }

  // metodo che restituisce tutti i pannelli memorizzati localmente
  getTts() {
    return this.tts;
  }
  getTtscount() {
    return this.ttscount;
  }
  // metodo richiamato all'inserimento di un nuovo pannello; viene identificata la posizione nella tabella dell'elemento da aggiungere
  setTts(tts: Tts[]) {
    if (tts !== null) {
      this.tts = tts;
      if (this.tts) this.ttsChanged.next(this.tts.slice()); else this.ttsChanged.next([])

    }
  }
  setTtscount(ttscount: string) {
    if (ttscount !== null) {
      this.ttscount = ttscount;
      this.ttscountChanged.next(this.ttscount.slice());
    }
  } 
}
